import { offstreetClient } from "../../api/client";

export const useFeatureFlags = (): Record<string, boolean> & { isPending: boolean } => {
	const { data, isPending } = offstreetClient.featureFlags.getFeatureFlags.useQuery(undefined, {
		staleTime: 1 * 60 * 1000,
	});

	return { ...(data || {}), isPending };
};
